"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Color_1 = __importDefault(require("./Color"));
const Usage = function (props) {
    const { value, label, colors, width } = props;
    return (react_1.default.createElement("div", { className: "glx-usage-comp", style: { width } },
        react_1.default.createElement("div", { className: "glx-usage-comp-bar" },
            react_1.default.createElement("div", { style: {
                    width: `${value}%`,
                    height: '4px',
                    backgroundColor: (0, Color_1.default)(value, colors),
                } })),
        react_1.default.createElement("div", { className: "glx-usage-comp-label" }, label)));
};
Usage.defaultProps = {
    colors: undefined,
    width: undefined,
};
exports.default = Usage;
